import { ApiResponse } from '../../../../constants/types';
import {
  AttemptInfo,
  StudentAssignmentItem,
  StudentAssignmentOrderByType,
  StudentProgress,
} from '../../../../constants/types/student/homework/type';
import { AssignmentStatusType } from '../../../../constants/types/lms/type';
import instance from '../../../axios/utils.ts/instance';

interface StudentAssignmentListParams {
  classId: string;
  status?: AssignmentStatusType;
  book?: string;
  orderBy?: StudentAssignmentOrderByType;
}

/**
 * 학생 페이지 > 내 학습 : 과제 목록 조회
 * @param classId
 * @returns
 */
export const getStudentAssignmentList = async (
  params: StudentAssignmentListParams,
) => {
  const { classId, ...rest } = params;

  const response = await instance.get<
    ApiResponse<{ items: StudentAssignmentItem[] }>
  >(`/v1/lms/my-assignments?classId=${classId}`, { params: rest });

  return response.data.data;
};

/**
 * 학생 페이지 > 내 학습 : 학습 현황 조회
 * @param classId
 * @returns
 */
export const getStudentProgress = async (classId: string) => {
  const response = await instance.get<ApiResponse<StudentProgress>>(
    `/v1/lms/my-progress?classId=${classId}`,
  );

  return response.data.data;
};

/**
 * 학생 페이지 > 내 학습 : 학습 상태 변경
 * 학생 할일 상태 변경
 * @param classId
 * @param todoId
 * @param status
 */
export const patchStudentAssignmentStatus = async (
  classId: string,
  todoId: number,
  status: string,
) => {
  const response = await instance.patch(
    `/v1/student/class/${classId}/todo/${todoId}`,
    { status: status },
  );

  return response.data;
};

/**
 * 학생 페이지 > 내 학습 : 과제 응시 횟수 조회
 * @param todoId
 * @returns
 */
export const getAssignmentAttemptInfo = async (todoId: number) => {
  const response = await instance.get<ApiResponse<AttemptInfo>>(
    `/v1/lms/todo/${todoId}/attempt-count`,
  );

  return response.data.data;
};
